// extracted by mini-css-extract-plugin
export default {"wrapper":"Error_wrapper__Ak+4K"};